import bottle from './bottle';

const {
  search, termsFromJson, getSession, setSession,
} = bottle().container;

export { search, termsFromJson, getSession, setSession };

